import { setResetUserInfo, setToken, useAppDispatch } from '../../app';

export const useLogout = () => {
  const dispatch = useAppDispatch();

  const logout = () => {
    dispatch(setResetUserInfo());
    dispatch(setToken(undefined));
  };

  return { logout };
};
